import { render, staticRenderFns } from "./PublishManagementModal.vue?vue&type=template&id=d13ad9b4&"
import script from "./PublishManagementModal.vue?vue&type=script&lang=js&"
export * from "./PublishManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./PublishManagementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PublishManagementModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/PublishManagementModal.vue
// module id = 2336
// module chunks = 1